// Load in the modules to test the endpoints
require('./api.js');
require('./apiMe.js');
require('./apiMeAlbum.js');
require('./apiMeAlbums.js');
require('./apiMeFriends.js');
require('./apiMePhotos.js');
